<template>
  <div>
    <v-toolbar color="primary" fixed app class="full-nav">
      <v-toolbar-title class="ml-0">
        <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
      </v-toolbar-title>
      <v-toolbar-title class="ml-0">
        <span>Vietmap Motrak</span>
      </v-toolbar-title>
      <button class="new-version-btn ml-3" @click="openNewVersion()" >
        <span class="label">Phiên bản mới!</span>
        <span class="gradient-container">
          <span class="gradient"></span>
        </span>
      </button>
      <v-spacer></v-spacer>
      <v-menu offset-y origin="center center" class="elelvation-1" :nudge-bottom="14">
        <v-btn icon flat slot="activator" @click="markAllAsRead()">
          <v-badge color="red" overlap v-show="unread > 0">
            <span slot="badge">{{unread}}</span>
            <v-icon medium>notifications</v-icon>
          </v-badge>
          <v-icon medium v-show="unread === 0">notifications</v-icon>
        </v-btn>
        <notification-list :datasource="notificationItems"></notification-list>
      </v-menu>&nbsp;
      &nbsp;
      <v-menu offset-y origin="center center" :nudge-bottom="16" :nudge-right="12">
        <v-toolbar-title class="ml-0" slot="activator">
          <span>
            <small>
              <span v-if="loggedUser">
                {{loggedUser.phone}}
              </span>
              <v-icon>expand_more</v-icon>
            </small>
          </span>
        </v-toolbar-title>
        <v-list class="pa-0">
          <v-list-tile @click="accountDialog = true" ripple="ripple" rel="noopener">
            <v-list-tile-action>
              <v-icon>person</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Tài khoản</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="logout()" ripple="ripple" rel="noopener">
            <v-list-tile-action>
              <v-icon>fullscreen_exit</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Đăng xuất</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <div class="text-xs-center">
      <v-dialog v-model="accountDialog" width="500">
        <v-card>
          <account @show="accountDialog = $event"/>
        </v-card>
      </v-dialog>
    </div>
    <DialogNewVersion ref="dialogNewVersion" @move-to-new-version="openNewVersion"/>
  </div>
</template>

<script>
import Util from '@/utils';
import colors from 'vuetify/es5/util/colors';
import NotificationList from '@/components/widgets/list/NotificationList';
import Account from '@/pages/account/index';
import * as DateTimeUtil from '@/utils/datetime';
import { mapActions, mapGetters } from 'vuex';
import * as Auth from '@/utils/auth';
import DialogNewVersion from '@/components/DialogNewVersion';

export default {
  name: 'app-toolbar',
  components: {
    NotificationList,
    Account,
    DialogNewVersion
  },
  data: () => ({
    colors: colors,
    notificationInterval: null,
    accountDialog: false,
    EXPIRATION_DATE: new Date('2025-05-05').getTime()
  }),

  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    },
    ...mapGetters(['loggedUser', 'notifications']),
    notificationItems () {
      let items = [];
      let list = this.notifications && this.notifications.slice(0, 7);
      if (!list) return items;
      list.map((a, index) => {
        let item = {
          id: a.id,
          title: a.title,
          content: a.content,
          isRead: a.isRead,
          color: a.notificationType === 'warning' ? 'primary' : 'red',
          icon: a.icon,
          timeLabel: DateTimeUtil.convertSecondToRelativeTime(a.createDate)
        };
        items.push(item);

        if (index < list.length - 1) {
          items.push({ divider: true, inset: true });
        }
        return 0;
      });
      return items;
    },
    unread () {
      return this.notifications && this.notifications.filter(a => !a.isRead).length || 0;
    }
  },

  mounted () {
    let a = window.location.href;
    if (!a.includes('sharing')) {
      let params = { pagesize: 50, pageIndex: 1 };
      this.getNotifications(params);
      if (this.notificationInterval === null) {
        this.notificationInterval = setInterval(() => {
          this.getNotifications(params);
        }, 10000);
      }
    }

    const shouldShowWelcomeDialog = this.checkShouldShowWelcomeDialog();
    if (shouldShowWelcomeDialog) {
      this.$refs.dialogNewVersion.open();
    }

  },

  created () {
    this.$vuetify.theme.primary = this.colors['amber'].base;
  },

  destroyed () {
    clearInterval(this.notificationInterval);
  },

  methods: {
    ...mapActions([
      'getUserInfo',
      'getNotifications',
      'markAllNotificationAsRead',
    ]),

    handleDrawerToggle () {
      window.getApp.$emit('APP_DRAWER_TOGGLED');
    },

    markAllAsRead () {
      this.markAllNotificationAsRead();
    },

    logout () {
      window.getApp.$emit('APP_LOGOUT');
    },

    openNewVersion () {
      window.open(`https://v2.motrak.vn/forceLogin?refreshToken=${Auth.getRefreshToken()}`, '_blank');
    },

    checkShouldShowWelcomeDialog () {
      if (this.EXPIRATION_DATE < Date.now()) {
        return false;
      }

      const welcomeDialog = JSON.parse(localStorage.getItem('NOT_SHOW_WELCOME_DIALOG') || 'false');

      const welcomeDialogSession = JSON.parse(sessionStorage.getItem('NOT_SHOW_WELCOME_DIALOG') || 'false');

      return !welcomeDialog && !welcomeDialogSession;
    }
  }
};
</script>

<style lang="stylus" scoped>
.full-nav {
  padding-left: 0 !important;
  z-index: 1000;
}

.hambuger-button {
  margin-left: -15px;
}

.v-toolbar {
  -webkit-box-shadow: none;
}
.new-version-btn {
  border: none;
  outline: none;
  background-color: #3a3a3a;
  font-size: 16px;
  color: #ffecb5;
  font-weight: 600;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  transition: all 0.3s;
}

.new-version-btn::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  width: 106%;
  height: 125%;
  z-index: -1;
  border-radius: inherit;
  transition: all 0.3s;
}

.gradient-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 106%;
  height: 115%;
  overflow: hidden;
  border-radius: inherit;
  z-index: -2;
  filter: blur(10px);
  transition: all 0.3s;
}

.gradient {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 110%;
  aspect-ratio: 1;
  border-radius: 100%;
  transition: all 0.3s;
  background-image: linear-gradient(
    90deg,
    hsl(226, 81%, 64%),
    hsl(271, 81%, 64%),
    hsl(316, 81%, 64%),
    hsl(1, 81%, 64%),
    hsl(46, 81%, 64%),
    hsl(91, 81%, 64%),
    hsl(136, 81%, 64%),
    hsl(181, 81%, 64%)
  );
  animation: rotate 2s linear infinite;
  filter: blur(10px);
}

.label {
  text-align: center;
  border-radius: 8px;
  background-color: rgba(43, 43, 43, 1);
  background-image: linear-gradient(
    180deg,
    rgb(43, 43, 43) 0%,
    rgb(68, 68, 68) 100%
  );
  padding: 0.25rem 0.75rem;
}

.new-version-btn:hover .gradient-container {
  transform: translate(-50%, -50%) scale(0.98);
  filter: blur(5px);
}

.new-version-btn:hover .gradient {
  filter: blur(5px);
}

@keyframes rotate {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppToolbar.vue